import React, {useEffect, useState, useRef, useMemo} from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import {Form, Button, message, Skeleton, Row} from 'antd';
import {desafectarNomina} from '../../../../apis/ProcesoNominaApi';
import {emit} from '../../../../apis/TimbradoApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import {status_period} from '@app/constants/period';
import _ from 'lodash'
import Result from './result'

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Nómina</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Procesos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Desafectar Nómina</span>
      </>
    ),
  }
];

const DesafectarNomina = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const refreshKey = useMemo(() => new URLSearchParams(location.search).get('refresh') || 'base', [location.search]);
    const [ form ] = Form.useForm()
    const [ loading, setLoading ] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [header, setHeader] = useState(null);  
    const [period, setPeriod] = useState(null);  

    const handleOk = async ({concepto}) => {
      setLoading(true);
      let success = false;
      const fields = form.getFieldsValue();
      const payload = {
          ...fields
      }
      const response = await desafectarNomina(payload);
      success = response.ok;
      if(response.ok){
          message.success('Se revirtió correctamente la nómina!');
      }

      setLoading(false);
      if(success){
        navigate(`${location.pathname}?refresh=${Date.now()}`, { replace: true });
      }
    }

    const handleTimbrarOk = async ({concepto}) => {
      setLoading(true);
      let success = false;
      const fields = form.getFieldsValue();
      const payload = {
          ...fields
      }
      await emit(payload);
      //await emitGet('recibo.pdf');
      setLoading(false);
      if(success){
        await resetBody();
      }
    }

    const resetBody = async ()=>{
      let values = await form.getFieldValue();
      form.resetFields();
      form.setFieldsValue({
        periodo_id: values.periodo_id,
        anio: values.anio,
        num_periodo: values.num_periodo,
      });
    }

    const onBlurHeader = async (values, period)=> {
      setHeader(values)
      if(values?.anio && values?.num_periodo && values?.periodo_id){
        setDisabled(false);
      }else{
        setDisabled(true);
      }

      if(period){
        setPeriod(period);
      }else{
        setPeriod(null)
      }
    }

    return <PageApp 
      routes={routes}
      title={'Desafectar Nómina'}>
        <AnioPeriodo key={refreshKey} onBlur={onBlurHeader} form={form} disabledForm={objectSelected && objectSelected.id > 0}/>
        <Row>
          <Button type="primary" onClick={handleOk} loading={loading} disabled={!period || period.status !== status_period.cerrado}>
            {loading ? 'Procesando': 'Desafectar Nomina'}
          </Button>
        </Row>
        <br/>
        {
          loading ? <Skeleton active={loading} />: <>
            {
              header && !disabledForm && <Result header={header} />
            }
          </>
        }

    </PageApp>
}   

export default DesafectarNomina;
